import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from '../../ui/Modal';
import PropTypes from 'prop-types';


import Translate, {t} from "../../../components/Translate";
import {selectConversationRequested} from "../../../services/chat/action";
import PlatformIcon from "../PlatformIcon";
import config from "../../../config";
import ChatMoreInfoModal from "../ChatMoreInfoModal";
import {generalModalStyles, hasManagementPermission, isValidTime} from "../../../utils/General";
import ExcelButton from "../../buttons/ExcelButton";
import {generateModalDataExcel, getModalData} from "../../../services/statistics/api";
import TablePagination from "../../table/TablePagination";
import LoadingComponent from "../../ui/LoadingComponent";
import TableHeaderSort from "../../table/TableHeaderSort";
import TableDateTime, {formatTableDateTime} from "../../table/TableDateTime";
import ResetButton from "../../buttons/ResetButton";
import Input from "../../form/Input";
import Colors from "../../../utils/Colors";
import colors from "../../../utils/Colors";
import Popup from "../../ui/Popup";
import SlidersHorizontalIcon from "../../../assets/icons/SlidersHorizontalIcon";
import DropdownSelect from "../../form/DropdownSelect";
import DatePicker from "../../form/DatePicker";
import TableAction from "../../table/TableAction";
import Tooltip from "../Tooltip";
import TimeInput from "../../form/TimeInput";
import TableScroll from "../../table/TableScroll";
import BlueButton from "../../buttons/BlueButton";
import SpeakerNotesIcon from "../../../assets/icons/SpeakerNotesIcon";
import ForumIcon from "../../../assets/icons/ForumIcon";
import BotAvatar from "../../../scenes/dashboard/components/management/clients/new/overview/BotAvatar";
import OperatorProfileDrawer from "../OperatorProfileDrawer";
import {getUserTodayRange} from '../../../utils/DateUtils';

const styles = {
    /*
     * Only what this table needs that the shared one does not: fixed columns and
     * a per-column width. The fill, the text colour and the padding came from
     * here as inline styles, which outrank .custom-table however it is written -
     * so this table alone kept the old dark blue header.
     */
    table: {
        width: '100%',
        tableLayout: 'fixed',
    },
    th: {
        width: '12.5%', // 8 columns equally divided
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    td: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    userStack: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        minWidth: 0,
    },
    userCell: {
        fontWeight: 'bold',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    userSubCell: {
        fontSize: '11px',
        lineHeight: '15px',
        color: 'var(--ds-text-tertiary)',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    operatorButton: {
        display: 'inline-block',
        maxWidth: '100%',
        padding: 0,
        border: 0,
        background: 'transparent',
        color: 'var(--ds-text-primary)',
        font: 'inherit',
        fontWeight: 'inherit',
        cursor: 'pointer',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
    }
};


Modal.setAppElement('#root');

class StatisticsConvModal extends Component {
    constructor(props) {
        super(props);

        this.subCompanies = (props.company && props.company.subs) ? props.company.subs : [];

        this.defaultFilters = {
            type: props.header,
            companyIds: this.subCompanies.map(sub => sub.id),
            chatId: '',
            operator: '',
            operatorId: null,
            user: '',
            platforms: [],
            bots: [],
            statuses: [],
            forwarded: null,
            unanswered: null,
            start: null,
            end: null,
            ratingScores: [],
            chatWithOperatorRequestCount: '',
            maxWaitingTimeForOperatorInSeconds: '',
            requestToOperatorStartHour: "00:00",
            requestToOperatorEndHour: "00:00",
        };

        this.state = {
            isInnerModalOpen: false,
            selectedChat: null,
            filteredConversations: [],
            scrollTop: 0,
            pageable: {
                page: 0,
                size: 10,
                sort: 'createdAt,desc'
            },
            totalElements: 0,
            totalPages: 0,
            filters: {
                type: props.header,
                companyIds: this.subCompanies.map(sub => sub.id),
                chatId: '',
                operator: '',
                operatorId: null,
                user: '',
                platforms: [],
                bots: [],
                statuses: [],
                forwarded: null,
                unanswered: null,
                start: null,
                end: null,
                ratingScores: [],
                chatWithOperatorRequestCount: '',
                maxWaitingTimeForOperatorInSeconds: '',
                requestToOperatorStartHour: "00:00",
                requestToOperatorEndHour: "00:00",
            },
            // display-only fields for the max operator waiting-time filter (combined into seconds)
            waitMinutes: '',
            waitSeconds: '',
            conversations: [],
            blockedFilters: {},
            isFetching: false,
            isFetchingExcel: false,
            operatorProfile: null
        };
        this.fetchTimeout = null;
        this.botHeaders = [
            'botsAllRequests',
            'solvedBotsRequests',
            'expiredBotsRequests',
            'transferredToOperatorBotsRequests',
            'ratedBotsRequests',
        ];
        this.headers = [
            {translateKey: 'id', sortColumn: 'conversation.id'},
            {translateKey: 'company', sortColumn: 'companyInfo.companyName'},
            {translateKey: 'platform', sortColumn: 'platform'},
            {translateKey: 'Status', sortColumn: 'status'},
            {translateKey: 'user', sortColumn: 'user.firstName,user.lastName'},
            {translateKey: 'operator', sortColumn: 'operator.firstName,operator.lastName'},
            {
                translateKey: 'requestToOperatorDateShort',
                tooltipKey: 'requestToOperatorDate',
                operatorOnly: true
            },
            {
                translateKey: 'operatorJoinedDateShort',
                tooltipKey: 'operatorJoinedDate',
                operatorOnly: true
            },
            {translateKey: 'createdAt', sortColumn: 'createdAt'},
            {translateKey: '', key: 'actions'},
        ]

        const propFilters = this.props.filters || {};
        this.initialFiltersState = {
            ...this.state.filters,
            ...propFilters,
            platforms: Array.isArray(propFilters.platforms)
                ? propFilters.platforms
                : propFilters.platforms ? [propFilters.platforms] : this.state.filters.platforms,
            statuses: Array.isArray(propFilters.statuses)
                ? propFilters.statuses
                : propFilters.statuses ? [propFilters.statuses] : this.state.filters.statuses,
            ...(props.header === 'todaysRequestsToOperator' ? getUserTodayRange() : {}),
        }
    }

    componentDidMount() {
        const initialWait = this.initialFiltersState.maxWaitingTimeForOperatorInSeconds;
        const propFilters = this.props.filters || {};

        this.setState({
            filters: {
                ...this.initialFiltersState,
            },
            // seed the min/sec display fields if an initial waiting-time value was provided
            waitMinutes: initialWait ? String(Math.floor(initialWait / 60)) : '',
            waitSeconds: initialWait ? String(initialWait % 60) : '',
        }, this.fetchData)

        this.setState({
            blockedFilters: {
                platforms: Array.isArray(propFilters.platforms)
                    ? propFilters.platforms.length > 0
                    : !!propFilters.platforms,
                bots: !!propFilters.bots,
                operator: !!propFilters.operator,
                statuses: Array.isArray(propFilters.statuses)
                    ? propFilters.statuses.length > 0
                    : !!propFilters.statuses,
                ratingScores: !!propFilters.ratingScores,
                start: this.props.header === 'todaysRequestsToOperator',
                end: this.props.header === 'todaysRequestsToOperator',
            }
        })
    }

    updateFilter(key, value, debounced = false) {
        if ((key === 'start' || key === 'end') && this.state.blockedFilters[key]) return;
        this.setState({
                filters: {
                    ...this.state.filters,
                    [key]: value
                },
                pageable: {
                    ...this.state.pageable,
                    page: 0
                }
            },
            () => {
                if (key === 'requestToOperatorStartHour' || key === 'requestToOperatorEndHour') {
                    if (!isValidTime(value)) return;
                }
                if (!debounced) {
                    this.fetchData();
                    return;
                }
                clearTimeout(this.fetchTimeout);
                this.fetchTimeout = setTimeout(() => {
                    this.fetchData();
                }, 300)

            })
    }

    // combine the minutes/seconds inputs into a single seconds value for the backend filter
    updateWaitingTime(part, rawValue) {
        const cleaned = (rawValue || '').replace(/[^\d]/g, '');

        const next = {
            waitMinutes: this.state.waitMinutes,
            waitSeconds: this.state.waitSeconds,
            [part]: cleaned,
        };

        const minutes = parseInt(next.waitMinutes, 10) || 0;
        const seconds = parseInt(next.waitSeconds, 10) || 0;
        const totalSeconds = minutes * 60 + seconds;

        // backend maps this to a Java int; reject the keystroke if the sum would overflow
        const MAX_INT = 2147483647;
        if (totalSeconds > MAX_INT) {
            return;
        }

        this.setState({
            waitMinutes: next.waitMinutes,
            waitSeconds: next.waitSeconds,
        });

        // empty string keeps the param out of the request (backend defaults to -1 = no filter)
        this.updateFilter('maxWaitingTimeForOperatorInSeconds', totalSeconds > 0 ? totalSeconds : '', true);
    }

    isRequestToBotsModal() {
        const {header} = this.props;
        return this.botHeaders.includes(header);
    }

    updatePageable(key, value) {
        const pageable = {
            ...this.state.pageable,
            [key]: value
        }

        if (key === 'size') {
            pageable.page = 0
        }

        this.setState({
                pageable
            },
            this.fetchData
        )
    }

    handleSort(column) {
        if (!column) return

        const sort = this.state.pageable.sort;
        let newSort
        let currentColumn, currentOrder

        if (sort) {
            currentOrder = sort.split(',').pop();
            currentColumn = sort.split(',').slice(0, -1).join(',');
        }

        if (currentOrder && currentColumn === column) {
            newSort = column + ',' + (currentOrder === 'asc' ? 'desc' : 'asc');
        } else {
            newSort = column + ',' + 'asc'
        }

        this.setState({
                pageable: {
                    ...this.state.pageable,
                    sort: newSort,
                }
            },
            this.fetchData
        )
    }

    resetFilters() {
        const initialWait = this.initialFiltersState.maxWaitingTimeForOperatorInSeconds;

        this.setState({
            filters: {
                ...this.initialFiltersState,
            },
            waitMinutes: initialWait ? String(Math.floor(initialWait / 60)) : '',
            waitSeconds: initialWait ? String(initialWait % 60) : '',
            pageable: {
                ...this.state.pageable,
                page: 0
            }
        }, this.fetchData)
    }

    isResetFiltersActive() {
        return Object.entries(this.initialFiltersState)
            .some(([key, value]) => value !== this.state.filters[key])
    }

    fetchData() {
        this.setState({
            isFetching: true
        })

        getModalData(this.state.filters, this.state.pageable).then(result => {
            if (result && result.content && result.pageable) {
                this.setState({
                    conversations: result.content,
                    pageable: {
                        page: result.pageable.pageNumber,
                        size: result.pageable.pageSize,
                        sort: this.state.pageable.sort
                    },
                    totalElements: result.totalElements,
                    totalPages: result.totalPages === 0 ? 1 : result.totalPages,
                })
            } else {
                this.setState({
                    conversations: [],
                    totalPages: 1,
                    totalElements: 0
                })
            }
        }).catch(e => {
            this.setState({
                conversations: [],
                totalPages: 1,
                totalElements: 0
            })
        }).finally(() => {
            this.setState({
                isFetching: false
            })
        });
    }

    closeModal = () => {
        this.props.cancelAction();
    };

    openTrModal = (conversation) => {
        this.setState({
            selectedChat: conversation,
            isInnerModalOpen: true,
        });
    };

    closeInnerModal = () => {
        this.setState({
            selectedChat: null,
            isInnerModalOpen: false,
        });
    };

    openOperatorProfile = (conversationDetails) => {
        if (!this.props.user || !this.props.user.authorities || !hasManagementPermission(this.props.user)) return;
        if (!conversationDetails.operatorId || conversationDetails.operatorFullName === 'null null') return;
        const nameParts = (conversationDetails.operatorFullName || '').trim().split(/\s+/).filter(Boolean);
        this.setState({
            operatorProfile: {
                id: conversationDetails.operatorId,
                fullName: conversationDetails.operatorFullName,
                firstName: nameParts[0],
                lastName: nameParts.slice(1).join(' '),
            }
        });
    };

    closeOperatorProfile = () => {
        this.setState({operatorProfile: null});
    };

    onScroll = (e) => {
        this.setState({scrollTop: e.target.scrollTop});
    };

    handleExport = () => {
        const {header} = this.props;
        this.setState({isFetchingExcel: true})
        generateModalDataExcel(header, this.state.filters).finally(() => {
            this.setState({isFetchingExcel: false});
        })
    };

    getChangedFiltersCount() {
        const {filters} = this.state;
        const defaults = this.defaultFilters;
        let count = 0;

        Object.keys(defaults).forEach((key) => {
            if (key === 'type' || key === 'operatorId' || key === 'forwarded' || key === 'unanswered') return;

            const current = filters[key];
            const base = defaults[key];

            if (Array.isArray(current)) {
                if (JSON.stringify(current) !== JSON.stringify(base)) count++;
            } else if (current !== base) {
                count++;
            }
        });

        return count;
    }

    renderRow = (conversationDetails) => {
        const {showConversationHistory, header} = this.props;
        const {showFullConversationHistory} = this.props;
        const canViewOperatorProfile = this.props.user
            && this.props.user.authorities
            && hasManagementPermission(this.props.user);

        const isBotConversation = this.botHeaders.includes(header);
        const language = this.props.user.language;
        const tooltipDate = value => {
            const formatted = formatTableDateTime(value, language);
            return formatted ? `${formatted.date} ${formatted.time}` : '';
        };
        const operatorDateCellStyle = {
            ...styles.td,
            whiteSpace: 'normal',
            overflow: 'visible',
            textOverflow: 'clip',
            lineHeight: '1.35',
        };

        return (
            <tr
                key={conversationDetails.conversationId + conversationDetails.createdAt}
                className={'clickable-row'}
                onClick={() => this.openTrModal(conversationDetails)}
            >
                <td style={styles.td}>{conversationDetails.conversationId}</td>
                <td style={styles.td}>{conversationDetails.botName}</td>
                <td style={{...styles.td,}}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'var(--ds-spacing-md)',
                        minWidth: '0'
                    }}>
                        <PlatformIcon conversation={conversationDetails} size={22} style={{flexShrink: 0}}/>
                        <span
                            style={{
                                minWidth: '0',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}>
                            {conversationDetails.platform.charAt(0).toUpperCase() + conversationDetails.platform.slice(1).toLowerCase()}
                        </span>
                    </div>
                </td>
                <td style={{...styles.td, whiteSpace: 'none'}}>
                    <Translate text={conversationDetails.status}/>
                </td>
                <td style={styles.td}>
                    {/*
                      * The stack is a div inside the cell, not the cell itself.
                      * display: flex on a <td> takes it out of the table layout:
                      * it stops being a table-cell, so it no longer shares the
                      * row's height or its borders, and it drew as a white block
                      * cutting the row in two.
                      */}
                    <div style={styles.userStack}>
                        <div style={styles.userCell}>
                            {conversationDetails.customerName}
                        </div>
                        {conversationDetails.visitorEmail &&
                            <div style={styles.userSubCell}>{conversationDetails.visitorEmail}</div>}
                        {conversationDetails.visitorPhoneNumber &&
                            <div style={styles.userSubCell}>{conversationDetails.visitorPhoneNumber}</div>}
                    </div>
                </td>
                <td style={{...styles.td, fontWeight: 'bold'}}>
                    {canViewOperatorProfile && conversationDetails.operatorId && conversationDetails.operatorFullName !== 'null null' ? (
                        <button
                            type="button"
                            className="statistics-modal__operator-button"
                            style={styles.operatorButton}
                            onClick={(event) => {
                                event.stopPropagation();
                                this.openOperatorProfile(conversationDetails);
                            }}
                        >
                            {conversationDetails.operatorFullName}
                        </button>
                    ) : (
                        conversationDetails.operatorFullName
                    )}
                </td>
                {!isBotConversation && (
                    <td style={operatorDateCellStyle}>
                        <Tooltip text={tooltipDate(conversationDetails.requestToOperatorDate)} needTranslate={false}
                                 style={{whiteSpace: 'normal'}}>
                            <span><TableDateTime value={conversationDetails.requestToOperatorDate}
                                                 fallback="N/A"/></span>
                        </Tooltip>
                    </td>
                )}
                {!isBotConversation && (
                    <td style={operatorDateCellStyle}>
                        <Tooltip text={tooltipDate(conversationDetails.operatorJoinedDate)} needTranslate={false}
                                 style={{whiteSpace: 'normal'}}>
                            <span><TableDateTime value={conversationDetails.operatorJoinedDate} fallback="N/A"/></span>
                        </Tooltip>
                    </td>
                )}
                <td style={operatorDateCellStyle}>
                    <Tooltip text={tooltipDate(conversationDetails.createdAt)} needTranslate={false}
                             style={{whiteSpace: 'normal'}}>
                        <span><TableDateTime value={conversationDetails.createdAt} fallback="N/A"/></span>
                    </Tooltip>
                </td>
                <td style={styles.td}>
                    <div className="table-actions">
                        <TableAction
                            tooltip={'chatHistory'}
                            onClick={() => {
                                if (header !== 'activeRequests') {
                                    showConversationHistory(conversationDetails, isBotConversation);
                                } else {
                                    showFullConversationHistory(conversationDetails);
                                }
                            }}
                            icon={<ForumIcon width={18} height={18}/>}
                        />

                        {header !== 'activeRequests' && (
                            <TableAction
                                tooltip={'fullChatHistory'}
                                onClick={() => showFullConversationHistory(conversationDetails)}
                                icon={<SpeakerNotesIcon width={18} height={18}/>}
                            />
                        )}
                    </div>
                </td>
            </tr>
        );
    };

    render() {
        const {isOpen, header, user} = this.props;
        const {
            isInnerModalOpen,
            selectedChat,
            pageable,
            totalPages,
            totalElements,
            conversations,
            isFetching,
            isFetchingExcel,
            filters,
            blockedFilters,
            waitMinutes,
            waitSeconds,
            operatorProfile
        } = this.state;

        const changedFiltersCount = this.getChangedFiltersCount();
        const visibleHeaders = this.headers.filter(header => !header.operatorOnly || !this.isRequestToBotsModal());
        const compactHeaderWidths = {
            id: 7,
            platform: 7,
            actions: 12,
        };
        const contentHeaderWidth = (100 - Object.values(compactHeaderWidths).reduce((sum, width) => sum + width, 0))
            / (visibleHeaders.length - Object.keys(compactHeaderWidths).length);

        const selectedRatingScores = filters.ratingScores || [];
        const ratingOptions = [1, 2, 3, 4, 5].map(value => ({
            value,
            label: value.toString(),
        }))

        const selectedPlatforms = filters.platforms || [];
        const platformOptions = Object.entries(config.platformsMap)
            .filter(([key]) => key !== 'company' && key !== 'viber') // TODO remove viber from filtering when integration is finished
            .map(([key, v]) => (
                {
                    label: v.charAt(0).toUpperCase() + v.slice(1).toLowerCase(), value: v
                }
            ));

        const selectedBots = filters.bots || []
        const botOptions = this.subCompanies.map((bot) => ({
            value: bot.id,
            label: bot.name,
            bot
        }))

        const selectedStatuses = filters.statuses || [];
        const statusesOptions = config.conversationStatusesList.map((status) => ({
            value: status,
            label: t({text: status, user}),
        }));
        return (
            <React.Fragment>
                <Modal footer={null} closeTimeoutMS={config.closeTimeoutMS}
                       isOpen={isOpen}
                       modalClassName="statistics-conv-modal"
                       style={generalModalStyles.statisticsConvModalStyles}
                       title={<React.Fragment><Translate text={header}/> ({totalElements})</React.Fragment>}
                       onRequestClose={this.closeModal}>

                    <div className="statistics-modal" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: '1rem',
                        height: '100%',
                        maxHeight: '100vh',
                    }}
                    >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '0',
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                    <Popup
                                        direction="bottom"
                                        panelAlign={{horizontal: "right", vertical: ""}}
                                        trigger={
                                            <BlueButton
                                                variant={'soft'}
                                                styles={{
                                                    display: 'flex',
                                                    gap: '4px',
                                                    alignItems: 'center',
                                                    position: 'relative',
                                                    height: '36px'
                                                }}
                                            >
                                                <React.Fragment>
                                                    <SlidersHorizontalIcon stroke="currentColor"/>
                                                    <span style={{fontSize: '14px', marginLeft: '4px'}}>
                                               <Translate text="filters"/>
                                            </span>

                                                    {changedFiltersCount !== 0 && (
                                                        <div className="filter-count-badge">
                                                            {changedFiltersCount}
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            </BlueButton>
                                        }
                                        panelStyle={{width: 'calc(90vw - 76px)', overflow: 'visible'}}
                                        panelInnerStyle={{overflow: 'visible'}}
                                    >
                                        <div
                                            className="statistics-filters-grid"
                                        >
                                            <Input
                                                type="text"
                                                placeholder={t({text: 'searchByConversationID', user})}
                                                value={filters.chatId}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value)) {
                                                        this.updateFilter('chatId', value, true);
                                                    }
                                                }}
                                                style={{
                                                    width: 'calc(25% - 10px)',
                                                    height: '40px'
                                                }}
                                            />

                                            <Input
                                                type="text"
                                                placeholder={t({text: 'searchByOperator', user})}
                                                value={filters.operator}
                                                onChange={(e) => this.updateFilter('operator', e.target.value, true)}
                                                style={{
                                                    width: 'calc(25% - 10px)',
                                                    height: '40px'
                                                }}
                                                disabled={blockedFilters.operator}
                                            />

                                            <Input
                                                type="text"
                                                placeholder={t({text: 'searchByUser', user})}
                                                value={filters.user}
                                                onChange={(e) => this.updateFilter('user', e.target.value, true)}
                                                style={{
                                                    width: 'calc(25% - 10px)',
                                                    height: '40px'
                                                }}
                                            />

                                            <Input
                                                type="number"
                                                placeholder={t({text: 'operatorRequestCount', user})}
                                                value={filters.chatWithOperatorRequestCount}
                                                onChange={(e) => this.updateFilter('chatWithOperatorRequestCount', e.target.value, true)}
                                                style={{
                                                    width: 'calc(25% - 10px)',
                                                    height: '40px'
                                                }}
                                            />

                                            <DropdownSelect
                                                selectedValue={ratingOptions.filter(o => selectedRatingScores.includes(o.value))}
                                                options={ratingOptions}
                                                onChange={r => {
                                                    const ratingScores = selectedRatingScores.includes(r.value)
                                                        ? selectedRatingScores.filter(score => score !== r.value)
                                                        : selectedRatingScores.concat(r.value);
                                                    this.updateFilter('ratingScores', ratingScores);
                                                }}
                                                renderLabel={selected => selected.length ? selected.map(s => s.label).join(', ') : t({
                                                    text: 'allRatings',
                                                    user
                                                })}
                                                disabled={blockedFilters.ratingScores || isFetching}
                                                styles={{
                                                    width: 'calc(25% - 10px)',
                                                }}
                                                variant={'outline'}
                                            />

                                            <DropdownSelect
                                                selectedValue={platformOptions.filter(o => selectedPlatforms.includes(o.value))}
                                                options={platformOptions}
                                                onChange={platform => {
                                                    const platforms = selectedPlatforms.includes(platform.value)
                                                        ? selectedPlatforms.filter(value => value !== platform.value)
                                                        : selectedPlatforms.concat(platform.value);
                                                    this.updateFilter('platforms', platforms);
                                                }}
                                                renderLabel={selected => selected.length
                                                    ? selected.map(option => option.label).join(', ')
                                                    : t({text: 'allPlatforms', user})}
                                                disabled={blockedFilters.platforms || isFetching}
                                                styles={{
                                                    width: 'calc(25% - 10px)',
                                                }}
                                                variant={'outline'}
                                            >
                                                {option => (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        minWidth: 0
                                                    }}>
                                                        <PlatformIcon conversation={{platform: option.value}}
                                                                      size={22}/>
                                                        <span>{option.label}</span>
                                                    </div>
                                                )}
                                            </DropdownSelect>

                                            <DropdownSelect
                                                selectedValue={botOptions.filter(o => selectedBots.includes(o.value))}
                                                options={botOptions}
                                                onChange={(bot) => {
                                                    const bots = selectedBots.includes(bot.value)
                                                        ? selectedBots.filter(b => b !== bot.value)
                                                        : selectedBots.concat(bot.value)
                                                    this.updateFilter('bots', bots)
                                                }}
                                                renderLabel={selected => selected.length
                                                    ? selected.length < 4
                                                        ? selected.map(option => option.label).join(', ')
                                                        : t({
                                                        text: 'Bots',
                                                        user
                                                    }) + ` (${selected.length})`
                                                    : t({
                                                        text: 'allBots',
                                                        user
                                                    })}
                                                disabled={blockedFilters.bots || isFetching}
                                                styles={{
                                                    width: 'calc(25% - 10px)',
                                                }}
                                                variant={'outline'}
                                            >
                                                {option => (
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        minWidth: 0
                                                    }}>
                                                        <BotAvatar client={option.bot} size={26} imgSize={24}/>
                                                        <span style={{
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis'
                                                        }}>
                                                            {option.label}
                                                        </span>
                                                    </div>
                                                )}
                                            </DropdownSelect>

                                            <DropdownSelect
                                                selectedValue={statusesOptions.filter(o => selectedStatuses.includes(o.value))}
                                                options={statusesOptions}
                                                onChange={status => {
                                                    const statuses = selectedStatuses.includes(status.value)
                                                        ? selectedStatuses.filter(value => value !== status.value)
                                                        : selectedStatuses.concat(status.value);
                                                    this.updateFilter('statuses', statuses);
                                                }}
                                                renderLabel={selected => selected.length
                                                    ? selected.map(option => option.label).join(', ')
                                                    : t({text: 'allStatuses', user})}
                                                disabled={blockedFilters.statuses || isFetching}
                                                styles={{
                                                    width: 'calc(25% - 10px)',
                                                }}
                                                variant={'outline'}
                                            />


                                            {!this.isRequestToBotsModal() &&
                                                <div
                                                    style={{
                                                        width: 'calc(25% - 10px)',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '8px',
                                                    }}
                                                >
                                            <span style={{
                                                fontSize: '11px',
                                                color: colors.silverDark,
                                                paddingLeft: '2px'
                                            }}>
                                                <Translate text="maxWaitingTimeForOperator"/>
                                            </span>
                                                    <div style={{display: 'flex', gap: '8px'}}>
                                                        <Input
                                                            type="number"
                                                            min="0"
                                                            placeholder={t({text: 'min', user})}
                                                            value={waitMinutes}
                                                            onChange={(e) => this.updateWaitingTime('waitMinutes', e.target.value)}
                                                            disabled={isFetching}
                                                            style={{width: '100%', height: '40px'}}
                                                        />
                                                        <Input
                                                            type="number"
                                                            min="0"
                                                            placeholder={t({text: 'sec', user})}
                                                            value={waitSeconds}
                                                            onChange={(e) => this.updateWaitingTime('waitSeconds', e.target.value)}
                                                            disabled={isFetching}
                                                            style={{width: '100%', height: '40px'}}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {!this.isRequestToBotsModal() &&
                                                <div
                                                    style={{
                                                        width: 'calc(25% - 10px)',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '2px',
                                                    }}
                                                >
                                            <span style={{
                                                fontSize: '11px',
                                                color: colors.silverDark,
                                                paddingLeft: '2px'
                                            }}>
                                                <Translate text="requestToOperatorTime"/>
                                            </span>
                                                    <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                                                        <TimeInput
                                                            name="startHour"
                                                            value={filters.requestToOperatorStartHour ? filters.requestToOperatorStartHour : ""}
                                                            onChange={(e) => this.updateFilter('requestToOperatorStartHour', e.target.value, true)}
                                                            disabled={isFetching}
                                                            containerStyles={{
                                                                marginBottom: '0'
                                                            }}
                                                            inputStyles={{
                                                                height: '40px',
                                                            }}
                                                        />
                                                        -
                                                        <TimeInput
                                                            name="endHour"
                                                            value={filters.requestToOperatorEndHour ? filters.requestToOperatorEndHour : ""}
                                                            onChange={(e) => this.updateFilter('requestToOperatorEndHour', e.target.value, true)}
                                                            disabled={isFetching}
                                                            containerStyles={{
                                                                marginBottom: '0'
                                                            }}
                                                            inputStyles={{
                                                                height: '40px',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            <DatePicker
                                                value={filters.start}
                                                onChange={date => {
                                                    this.updateFilter('start', date);
                                                }}
                                                onReset={() => {
                                                    setTimeout(() => {
                                                        this.updateFilter('start', null)
                                                    }, 100)
                                                }}
                                                disabled={blockedFilters.start || isFetching}
                                                placeholder={'startDate'}
                                                panelAlign={{horizontal: "right", vertical: ""}}
                                                inputContainerStyle={{
                                                    height: '40px'
                                                }}
                                                popupStyle={{
                                                    width: 'calc(25% - 10px)',
                                                }}
                                            />

                                            <DatePicker
                                                value={filters.end}
                                                onChange={date => {
                                                    this.updateFilter('end', date);
                                                }}
                                                onReset={() => {
                                                    setTimeout(() => {
                                                        this.updateFilter('end', null)
                                                    }, 100)
                                                }}
                                                disabled={blockedFilters.end || isFetching}
                                                endOfDay
                                                placeholder={'endDate'}
                                                panelAlign={{horizontal: "left", vertical: ""}}
                                                inputContainerStyle={{
                                                    height: '40px'
                                                }}
                                                popupStyle={{
                                                    width: 'calc(25% - 10px)',
                                                }}
                                            />

                                        </div>
                                    </Popup>

                                    {
                                        this.isResetFiltersActive() &&
                                        <ResetButton
                                            onClick={() => this.resetFilters()}
                                            width={150}
                                            height={36}
                                            variant="outline"
                                            disabled={!this.isResetFiltersActive()}
                                        />
                                    }

                                </div>

                                <div>
                                    <ExcelButton
                                        onClick={this.handleExport}
                                        width={200}
                                        height={36}
                                        variant={'outline'}
                                        loading={isFetchingExcel}
                                        children={
                                            <span style={{fontSize: '12px', backgroundColor: 'transparent'}}>
                                        <Translate text={'downloadXls'}/>
                                    </span>
                                        }
                                    />
                                </div>
                            </div>


                            <TableScroll style={{overflow: 'auto'}} onScroll={this.onScroll} stickyActions>
                                <table
                                    className={'custom-table'}
                                    style={{
                                        ...styles.table,
                                        minWidth: this.isRequestToBotsModal() ? '900px' : '1200px',
                                    }}
                                >
                                    <thead>
                                    <tr>
                                        {visibleHeaders.map((header, index) => (
                                            <th
                                                key={header.key || header.translateKey}
                                                style={{
                                                    ...styles.th,
                                                    width: header.key === 'actions'
                                                        ? '88px'
                                                        : `${compactHeaderWidths[header.translateKey] || contentHeaderWidth}%`,
                                                }}
                                                onClick={() => this.handleSort(header.sortColumn)}
                                            >
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    justifyContent: index === visibleHeaders.length - 1 ? 'center' : 'start',
                                                }}>
                                                    {header.tooltipKey ? (
                                                        <Tooltip text={header.tooltipKey}>
                                                            <span><Translate text={header.translateKey}/></span>
                                                        </Tooltip>
                                                    ) : header.translateKey ? (
                                                        <Translate text={header.translateKey}/>
                                                    ) : null}
                                                    {
                                                        header.sortColumn
                                                        &&
                                                        <TableHeaderSort
                                                            isActive={pageable.sort.split(',').slice(0, -1).join(',') === header.sortColumn}
                                                            direction={pageable.sort.split(',').pop()}
                                                        />
                                                    }

                                                </div>
                                            </th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        !isFetching && conversations.map(this.renderRow)
                                    }
                                    {
                                        conversations.length === 0 && !isFetching &&
                                        <tr className="table-no-result">
                                            <td colSpan={visibleHeaders.length}
                                                style={{
                                                    textAlign: 'center',
                                                    padding: '40px',
                                                    color: Colors.silverWhiteSemiDark
                                                }}>
                                                <Translate text={'noResultsFound'}/>
                                            </td>
                                        </tr>
                                    }
                                    </tbody>
                                </table>
                                {
                                    isFetching
                                    &&
                                    <div style={{height: '150px'}}>
                                        <LoadingComponent/>
                                    </div>
                                }
                            </TableScroll>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexShrink: 0,
                            backgroundColor: 'var(--ds-bg-primary)',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                        }}>
                            <TablePagination
                                totalRows={totalElements}
                                numberOfPages={totalPages}
                                handleChangeRowsPerPage={(size) => this.updatePageable('size', size)}
                                rowsPerPage={pageable.size}
                                curPage={pageable.page}
                                selectPage={(page) => this.updatePageable('page', page)}
                            />
                        </div>

                    </div>

                </Modal>

                {user && user.authorities && hasManagementPermission(user) && (
                    <OperatorProfileDrawer
                        open={!!operatorProfile}
                        onClose={this.closeOperatorProfile}
                        operator={operatorProfile}
                        parentCompanyId={this.props.company && this.props.company.id}
                        filters={filters}
                    />
                )}

                {isInnerModalOpen && selectedChat && (
                    <ChatMoreInfoModal
                        useProvidedDetails
                        isOpen={true}
                        onRequestClose={this.closeInnerModal}
                        company={this.props.company}
                        conversation={selectedChat}
                    />
                )}

            </React.Fragment>
        );
    }
}

StatisticsConvModal.propTypes = {
    cancelAction: PropTypes.func,
    company: PropTypes.object,
    header: PropTypes.string,
    showConversationHistory: PropTypes.func,
    filters: PropTypes.object,
};

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    selectConversation: (conversation) => dispatch(selectConversationRequested(conversation)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsConvModal);



// WEBPACK FOOTER //
// ./src/components-new/general/statistics/StatisticsConvModal.jsx